export default __webpack_public_path__ + "static/sentiment3-82486c2393f2834d890294befe61384e.png";